import ContactPage from 'src/@legacy/wrapper/contact/ContactPage'
import withHeaderLP from 'src/@legacy/layout/hoc/withHeaderLP'

import withAppProvider from 'src/@legacy/layout/hoc/withAppProvider'
export default withAppProvider(withHeaderLP(ContactPage))
